import YTO from '@/assets/send/YTO@2x.png'
import SF from '@/assets/send/SF@2x.png'
import STO from '@/assets/send/STO@2x.png'
import EMS from '@/assets/send/ems@2x.png'
import JD from '@/assets/send/JD@2x.png'
import YD from '@/assets/send/YD@2x.png'
import HTKY from '@/assets/send/HTKY@2x.png'
import DBL from '@/assets/send/DBL@2x.png'
import ZTO from '@/assets/send/ZTO@2x.png'

export default {
  ZTO,
  YTO,
  SF,
  STO,
  EMS,
  JD,
  YD,
  DBL,
  HTKY
}
